const axios = require('axios');

const salaryCheckerLambda = async (url, params) => {
  const apikeyParams = {
    apikey: typeof window !== 'undefined' ? window.apigeeKey : '',
  };
  const mergedParams = { ...apikeyParams, ...params };
  return axios.get(`${process.env.REACT_APP_APIGEE_LAMBDA_ENDPOINT}/${url}`, { params: mergedParams });
};

export default salaryCheckerLambda;
